var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9932 4.13581C9.9938 1.7984 6.65975 1.16964 4.15469 3.31001C1.64964 5.45038 1.29697 9.02898 3.2642 11.5604C4.89982 13.6651 9.84977 18.1041 11.4721 19.5408C11.6536 19.7016 11.7444 19.7819 11.8502 19.8135C11.9426 19.8411 12.0437 19.8411 12.1361 19.8135C12.2419 19.7819 12.3327 19.7016 12.5142 19.5408C14.1365 18.1041 19.0865 13.6651 20.7221 11.5604C22.6893 9.02898 22.3797 5.42787 19.8316 3.31001C17.2835 1.19216 13.9925 1.7984 11.9932 4.13581Z",
    stroke: "#F4FBFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ed14bd710270fdf70b01065563bbdc9f.svg";
export { ForwardRef as ReactComponent };